export default __webpack_public_path__ + "static/media/icon_buscar.96aabd79.svg";